import { useState, useEffect } from 'react';

const LS_KEY = 'hd_last_seen_version';

export function useWhatsNew() {
  const [show,      setShow]      = useState(false);
  const [changelog, setChangelog] = useState([]);
  const [version,   setVersion]   = useState('');

  useEffect(() => {
    const token = localStorage.getItem('hd_token');
    if (!token) return;

    fetch('/api/version', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(({ version: v, changelog: log }) => {
        setVersion(v);
        setChangelog(log || []);
        const seen = localStorage.getItem(LS_KEY);
        if (seen !== v) setShow(true);
      })
      .catch(() => {});
  }, []);

  function dismiss() {
    localStorage.setItem(LS_KEY, version);
    setShow(false);
  }

  function open() { setShow(true); }

  const hasUnseen = show;

  return { show, changelog, version, dismiss, open, hasUnseen };
}
